/* eslint-disable no-console */
import { SOPIProps } from '../hooks/useEditRemoveSOP'

import { StandardOperatingProceduresQuery } from '@/graphql/generated/operations'
import {
  OrderDirection,
  StandardOperatingProcedureOrderField,
} from '@/graphql/generated/schemas'

import { SOPsRowDataType } from '../types/types'

const orderByMapping: Record<string, StandardOperatingProcedureOrderField> = {
  name: StandardOperatingProcedureOrderField.Name,
  date: StandardOperatingProcedureOrderField.CreatedAt,
}

export const getOrderBy = (
  sortColumn: string | null,
  sortOrder: 'asc' | 'desc' | null
): {
  direction: OrderDirection
  field: StandardOperatingProcedureOrderField
}[] => {
  const field = sortColumn ? orderByMapping[sortColumn] : null
  if (!field || !sortOrder) {
    return [
      {
        direction: OrderDirection.Desc,
        field: StandardOperatingProcedureOrderField.CreatedAt,
      },
    ]
  }
  return [
    {
      direction:
        sortOrder === 'desc' ? OrderDirection.Desc : OrderDirection.Asc,
      field,
    },
  ]
}

export const formatTableData = (
  sopData: StandardOperatingProceduresQuery,
  onEdit: (sop: SOPIProps) => void,
  onRemove: (sop: SOPIProps) => void
): SOPsRowDataType[] => {
  const sops =
    sopData?.standardOperatingProcedures?.edges?.map((e) => e.node) || []
  return sops.map((e) => {
    return {
      id: e?.id,
      name: e?.name,
      date: e?.createdAt,
      creator: e?.creator,
      type: e?.type,
      facilities: {
        facilities: e?.facilities?.edges,
        onEdit: () => onEdit({ id: e?.id, name: e?.name }),
        onRemove: () => onRemove({ id: e?.id, name: e?.name }),
      },
    }
  })
}
